import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { PatientPharmacotherapyInput } from '../models/patient-pharmacotherapy-model';
import { PatientPharmacotherapy } from '../models/patient-model';

@Injectable({
  providedIn: 'root',
})
export class PatientPharmacoterapiesService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  addHeader(): HttpHeaders {
    const token = sessionStorage.getItem('psicogeniusAccessToken');

    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  getPatientPharmacoterapies(
    patientId: string
  ): Observable<PatientPharmacotherapy[]> {
    const endpoint =
      this.apiUrl + '/patients/' + patientId + '/pharmacotherapies';
    const headers = this.addHeader();
    return this.http.get<PatientPharmacotherapy[]>(endpoint, { headers });
  }

  createPatientPharmacoterapies(
    patientPharmacoterapies: PatientPharmacotherapyInput
  ): Observable<PatientPharmacotherapy> {
    const endpoint = this.apiUrl + '/patient-pharmacotherapies';
    const headers = this.addHeader();
    return this.http.post<PatientPharmacotherapy>(
      endpoint,
      patientPharmacoterapies,
      { headers }
    );
  }

  updatePatientPharmacoterapies(
    patientPharmacoterapies: PatientPharmacotherapyInput,
    pharmacotherapyId: string
  ): Observable<PatientPharmacotherapy> {
    const endpoint =
      this.apiUrl + '/patient-pharmacotherapies/' + pharmacotherapyId;
    const headers = this.addHeader();
    return this.http.put<PatientPharmacotherapy>(
      endpoint,
      patientPharmacoterapies,
      { headers }
    );
  }

  deletePatientPharmacoterapies(pharmacotherapyId: string): Observable<void> {
    const endpoint =
      this.apiUrl + '/patient-pharmacotherapies/' + pharmacotherapyId;
    const headers = this.addHeader();
    return this.http.delete<void>(endpoint, { headers });
  }

  getPatientPharmacotherapy(
    pharmacotherapyId: string
  ): Observable<PatientPharmacotherapy> {
    const endpoint =
      this.apiUrl + '/patient-pharmacotherapies/' + pharmacotherapyId;
    const headers = this.addHeader();
    return this.http.get<PatientPharmacotherapy>(endpoint, { headers });
  }
}
